exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nbody[data-v-b4c1649a], p[data-v-b4c1649a], div[data-v-b4c1649a], span[data-v-b4c1649a], article[data-v-b4c1649a], section[data-v-b4c1649a] {\n  text-align: left !important;\n  text-justify: none !important;\n  word-spacing: normal !important;\n  letter-spacing: normal !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-b4c1649a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/module/sm_vip_privacy_en/sm_vip_privacy_en.vue
// module id = 374
// module chunks = 15